
import Vue from 'vue'
import { MultipleUnitsItem } from '@/model/index'

interface UnitsTableItem {
  unitRange: string
  unitNumber: string
}

export default Vue.extend({
  props: {
    unitsList: {
      type: Array as () => MultipleUnitsItem[],
      required: true
    },
    quantityUnit: {
      type: String,
      required: true
    },
    bodyClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    multipleUnitsToolipItems(): UnitsTableItem[] {
      return this.unitsList.map((element, index) => {
        if (index < this.unitsList.length - 1) {
          return {
            unitRange:
              element.quantity_greater_than +
              '〜' +
              this.unitsList[index + 1].quantity_greater_than +
              this.quantityUnit,
            unitNumber: element.unit_num + this.quantityUnit
          }
        } else {
          return {
            unitRange: element.quantity_greater_than + this.quantityUnit + '〜',
            unitNumber: element.unit_num + this.quantityUnit
          }
        }
      })
    }
  },
  mounted() {
    const container = this.$refs.container as HTMLElement

    document.querySelector('body')!.addEventListener('click', e => {
      if (container && !container.contains(e.target as Node)) {
        this.close()
      }
    })
  },
  methods: {
    close(): void {
      this.$emit('close')
    }
  }
})
